export default "__VITE_ASSET__CB5UMzS1__"